export interface ExchangeRate {
  id: string;
  currency: number; // likely an enum or numeric ID
  rateToUSD: number; // DEPRECATED: the legacy buy/compra rate, NOT the average. Post/convert with averageRateToUSD (#5221).
  buyRateToUSD?: number; // compra
  sellRateToUSD?: number; // venta
  averageRateToUSD?: number; // Promedio (derived server-side)
  financialInstitution?: string | null; // e.g. "Banco Central de Honduras"
  effectiveDate: string; // ISO date string
  source: number; // likely an enum or numeric ID
}

export interface ExchangeRateSearchCommand {
  date?: string | null;
  currency?: number | null;
}

/**
 * Filters for the rate history listing (#5225). Distinct from the search above, which answers a
 * single day and treats a null date as today — here absent filters mean every rate on record.
 */
export interface ExchangeRateHistoryCommand {
  fromDate?: string | null;
  toDate?: string | null;
  currency?: number | null;
}
export enum Currency {
  USD,
  HNL,
}
export enum SourceExchangeRate {
  MANUAL,
  API,
}
